import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterZSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLetterZSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM8.7207 7.77246V9.50098H12.623V9.6123L8.65625 14.8623V16.2275H15.3242V14.499H11.2344V14.3877L15.2012 9.1377V7.77246H8.7207Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterZSquare;
